import { useQuery } from '@tanstack/react-query'

import { api } from '../../../shared/api'

export function useEntryStats() {
  return useQuery({
    queryKey: ['entries', 'stats'],
    queryFn: () => api<Record<string, number>>('/entries/stats'),
  })
}
